
/**
 * TicketSalesReport.js
 * 用于解析和转换销售数据为表格数据结构
 */

// 全局变量，存储价格列表和员工映射
var priceList = [] // 价格列表，包含priceId、productName、crowdtypeName等信息
var staffMap = [] // 员工映射，包含staffId和staffName等信息

/**
 * 解析表格数据
 * @param {Object} apiReturnData - API返回的数据，包含priceList、saleList、refundList等字段
 * @param {Array} staff - 员工列表，包含staffId和staffName等信息
 * @returns {Array} - 转换后的表格数据结构
 */
export const parseTableData = (apiReturnData) => {
    priceList = apiReturnData.priceList
    staffMap = apiReturnData.staffList
    staffMap.push({staffId: 0, staffName: '其他'})
    const saleList = apiReturnData.saleList
    const refundList = apiReturnData.refundList
    
    let paramData = []
    for(let item of saleList){
        let param = paramData.find(param => param.date == item.createDay)
        if(param){
            param.productList = parseProductList(param.productList, item)

        }else{
            param = {
                date: item.createDay,
                productList: parseProductList([], item),
            }
            paramData.push(param)
        }
    }
    for(let item of refundList){
        let param = paramData.find(param => param.date == item.createDay)
        if(param){
            param.productList = parseProductList(param.productList, item)

        }else{
            param = {
                date: item.createDay,
                productList: parseProductList([], item),
            }
            paramData.push(param)
        }
    }
    let totalParamData = {
        date: '总计',
        productList: [],
    }
    for(let item of saleList){
        totalParamData.productList = parseProductList(totalParamData.productList, item)
    }
    for(let item of refundList){
        totalParamData.productList = parseProductList(totalParamData.productList, item)
    }
    paramData.push(totalParamData)
    return createTableData(paramData)
}

/**
 * 解析产品列表
 * @param {Array} productList - 产品列表
 * @param {Object} item - 销售或退款数据项
 * @returns {Array} - 更新后的产品列表
 */
export const parseProductList = (productList, item) => {
    const price = priceList.find(price => price.priceId == item.priceId)
    let productParam = productList.find(product => product.productName == price.productName)
    if(productParam){
        productParam.priceList = parsePriceList(productParam.priceList, item)
    }else{
        const priceData = parsePriceList([], item)
        productParam = {
            productName: price.productName,
            priceList: priceData,
        }
        productList.push(productParam)
    }
    return productList
}

/**
 * 解析价格列表
 * @param {Array} priceData - 价格列表
 * @param {Object} item - 销售或退款数据项
 * @returns {Array} - 更新后的价格列表
 */
export const parsePriceList = (priceData, item) => {
    const price = priceList.find(price => price.priceId == item.priceId)
    let priceParam = priceData.find(priceData => priceData.crowdtypeName == price.crowdtypeName)
    if(priceParam){
        priceParam.salePrice = parseSalePrice(priceParam.salePrice, item)
    }else{
        const salePrice = parseSalePrice([], item)
        priceParam = {
            crowdtypeName: price.crowdtypeName,
            salePrice: salePrice,
        }
        priceData.push(priceParam)
    }
    return priceData
}

/**
 * 解析销售价格列表
 * @param {Array} salePriceList - 销售价格列表
 * @param {Object} item - 销售或退款数据项
 * @returns {Array} - 更新后的销售价格列表
 */
export const parseSalePrice = (salePriceList, item) => {
    let salePriceParam = salePriceList.find(price => price.price == item.settlementPrice)
    if(salePriceParam){
        salePriceParam.staffList = parseStaffList(salePriceParam.staffList, item)
    }else{
        const staffList = parseStaffList([], item)
        salePriceParam = {
            price: item.settlementPrice,
            staffList: staffList,
        }
        salePriceList.push(salePriceParam)
    }
    return salePriceList
}

/**
 * 解析员工列表
 * @param {Array} staffList - 员工列表
 * @param {Object} item - 销售或退款数据项
 * @returns {Array} - 更新后的员工列表
 */
export const parseStaffList = (staffList, item) => {
    const staff = staffMap.find(staff => staff.staffId == item.staffId)
    let staffParam = staffList.find(staffitem => staffitem.staffId == staff.staffName)
    if(staffParam){
        staffParam = parseQuantity(staffParam, item)
    }else{
        staffParam = parseQuantity(null, item)
        staffList.push(staffParam)
    }
    return staffList
}

/**
 * 解析数量信息
 * @param {Object} staff - 员工对象
 * @param {Object} item - 销售或退款数据项
 * @returns {Object} - 更新后的员工对象
 */
export const parseQuantity = (staff, item) => {
    let staffParam = staff
    if(staffParam == null){
        const staffMapItem = staffMap.find(staff => staff.staffId == item.staffId)
        staffParam = {
            staffId: staffMapItem.staffName,
            quantity: 0,
            operateQuantity: 0,
            sealQuantity: 0,
            smallCount: 0,
            payCount: 0,
        }
    }
    if(item.operateQuantity && item.operateQuantity > 0){
        console.log(item)
        staffParam.operateQuantity = staffParam.operateQuantity + item.operateQuantity
        staffParam.sealQuantity = staffParam.sealQuantity - item.operateQuantity
        staffParam.smallCount = staffParam.smallCount - (item.operateQuantity * item.settlementPrice)
        staffParam.payCount = staffParam.payCount - (item.operateQuantity * item.settlementPrice)
    }
    if(item.quantity && item.quantity > 0){
        staffParam.quantity = staffParam.quantity + item.quantity
        staffParam.sealQuantity = staffParam.sealQuantity + item.quantity
        staffParam.smallCount = staffParam.smallCount + (item.quantity * item.settlementPrice)
        staffParam.payCount = staffParam.payCount + (item.quantity * item.settlementPrice)

    }
    return staffParam
}

/**
 * 创建表格数据结构
 * @param {Array} paramData - 按日期分组的数据
 * @returns {Array} - 转换后的表格数据结构
 */
export const createTableData = (paramData) => {
    let tableData = []
    let i = 1
    for(let param of paramData){
        let productRow = []
        let bigQuantity = 0
        let bigOperateQuantity = 0
        let bigSealQuantity = 0
        let bigSmallCount = 0
        let bigPayCount = 0
        for(let product of param.productList){
            let priceRow = []
            
            for(let price of product.priceList){
                let salePriceList = []
                for(let salePrice of price.salePrice){
                    let staffList = []
                    let smallQuantity = 0
                    let smallOperateQuantity = 0
                    let smallSealQuantity = 0
                    let smallSmallCount = 0
                    let smallPayCount = 0
                    for(let staff of salePrice.staffList){
                        let tr = [
                            { value: param.date, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                            { value: product.productName, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                            { value: price.crowdtypeName, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                            { value: salePrice.price/100, colspan: 0, rowspan: 0, class: 'qa-td-normal' },
                            { value: staff.staffId, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                            { value: staff.quantity, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                            { value: staff.operateQuantity, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                            { value: staff.sealQuantity, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                            { value: staff.payCount/100, colspan: 1, rowspan: 1, class: 'qa-td-normal' },
                        ]
                        staffList.push({ tr: tr })
                        smallQuantity = smallQuantity + staff.quantity
                        smallOperateQuantity = smallOperateQuantity + staff.operateQuantity
                        smallSealQuantity = smallSealQuantity + staff.sealQuantity
                        smallSmallCount = smallSmallCount + staff.smallCount
                        smallPayCount = smallPayCount + staff.payCount
                        bigQuantity = bigQuantity + staff.quantity
                        bigOperateQuantity = bigOperateQuantity + staff.operateQuantity
                        bigSealQuantity = bigSealQuantity + staff.sealQuantity
                        bigSmallCount = bigSmallCount + staff.smallCount
                        bigPayCount = bigPayCount + staff.payCount
                    }
                    
                    staffList[0].tr[3].rowspan = staffList.length
                    staffList[0].tr[3].colspan = 1
                    salePriceList.push(...staffList)
                    let tr = [
                        { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                        { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                        { value: '小计', colspan: 2, rowspan: 1, class: 'qa-td-subtotal' },
                        { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                        { value: '', colspan: 0, rowspan: 0, class: 'qa-td-subtotal' },
                        { value: smallQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                        { value: smallOperateQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                        { value: smallSealQuantity, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                        { value: smallPayCount/100, colspan: 1, rowspan: 1, class: 'qa-td-subtotal' },
                    ]
                    salePriceList.push({ tr: tr })
                }
                
                
                salePriceList[0].tr[2].rowspan = salePriceList.length
                salePriceList[0].tr[2].colspan = 1
                priceRow.push(...salePriceList)
                
            }
            
            priceRow[0].tr[1].rowspan = priceRow.length
            priceRow[0].tr[1].colspan = 1
            productRow.push(...priceRow)
        }
        let tr = [
            { value: '', colspan: 0, rowspan: 0, class: 'qa-td-total' },
            { value: '合计', colspan: 4, rowspan: 1, class: 'qa-td-total' },
            { value: '', colspan: 0, rowspan: 0, class: 'qa-td-total' },
            { value: bigQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            { value: bigOperateQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            { value: bigSealQuantity, colspan: 1, rowspan: 1, class: 'qa-td-total' },
            { value: bigPayCount/100, colspan: 1, rowspan: 1, class: 'qa-td-total' },
        ]
        productRow.push({ tr: tr })
        productRow[0].tr[0].rowspan = productRow.length
        productRow[0].tr[0].colspan = 1
        if(i == paramData.length){
            productRow[0].tr[0].class = 'qa-td-merged qa-th-merged'
        }
        tableData.push(...productRow)
        i++
    }
    return tableData
}